import { TopNav } from "@/components/TopNav"
import { PublicLink } from "./PublicLink"

// Entirely unaware of auth, deliberately and permanently — no session
// check, no LoggedInUser, "Go to App" always shown regardless of
// whether the visitor is signed in. An unauthenticated visitor who
// clicks it lands on /app, whose own guard redirects to /app/login —
// that redirect-to-login case is /app's own guard's job, not this
// page's. See m-public-landing-page-spa.md's Design section.
export function App() {
  return (
    <>
      <TopNav
        items={[
          {
            href: "/",
            label: <img src="/logo-bare.png" alt="BC Court Helper" width={40} height={32} />,
          },
        ]}
        rightItems={[{ href: "/app", label: "Go to App" }]}
        linkComponent={PublicLink}
      />
      <div className="mx-auto w-full max-w-5xl">
        <main className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
          <h1 className="max-w-xl text-3xl font-semibold text-zinc-900 dark:text-zinc-100">
            BC Court Helper is a work in progress — turning daily BC court list PDFs into something a lawyer can
            actually use.
          </h1>
          <p className="max-w-md text-base text-zinc-500 dark:text-zinc-400">
            It&apos;s currently open to a small group. Sign in if you&apos;re already part of it.
          </p>
        </main>
      </div>
    </>
  )
}
